import { render, staticRenderFns } from "./Interfaz_provedor.vue?vue&type=template&id=cd6682e4&lang=pug&"
import script from "./Interfaz_provedor.vue?vue&type=script&lang=js&"
export * from "./Interfaz_provedor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports